export const WHITELIST_DOMAINS: string[] = [
  "onlea.org",
  "ualberta.ca",
  "uiowa.edu",
];
